import './src/styles/global.css'; // Ensure Tailwind is imported here

import React from 'react';
import { AppProvider } from './src/contexts/AppContext';

// Only wrap with context provider - no layout here
export const wrapRootElement = ({ element }) => {
  return <AppProvider>{element}</AppProvider>;
};